export const printPage = (modalId: string, title: string) => {
    let divToPrint: any = document.getElementById(modalId)
    let htmlToPrint =
        '<h3 style="text-align:center; ">' +
        title +
        '</h3>' +
        '<style type="text/css">' +
        'body {font-family: "Open Sans", sans-serif;font-size: 1rem;line-height: 1.5;color: #343434;magin:50px;}' +
        'table {border-collapse:collapse;width:100% !important}' +
        '.table-bordered th {background-color: #eeeeee;text-align:left;-webkit-print-color-adjust: exact;}' +
        'table th, table td{ border: #b8b8b8 0.5px solid !important;padding: 0.55rem;font-size:13px;-webkit-print-color-adjust: exact;}' +
        '.print-btn{display: none;}' +
        '.title{font-weight: bold}' +
        '.pagination-container{display: none;}' +
        '.attachment-information{padding-bottom: 2rem}' +
        '.print-btn{display:none;}' +
        '</style>'
    htmlToPrint += divToPrint.outerHTML
    let newWin: any = window.open('')
    newWin.document.write(htmlToPrint)
    newWin.document.close()
    newWin.focus()
    newWin.print()
    newWin.close()
}
